import { useMemo } from "react";
import { URL_SOURCE_TYPE } from "src/utils/enums";
import { useRouteParams } from "src/hooks/useRouteParams";

// Custom hook to check if the hostUrl is either DIGITAL_AGENT or DIGITAL
export const useIsDigitalOrDigitalAgent = (): boolean => {
  const { currentSource } = useRouteParams();
  return useMemo(() => {
    return (
      currentSource === URL_SOURCE_TYPE.DIGITAL_AGENT ||
      currentSource === URL_SOURCE_TYPE.DIGITAL
    );
  }, [currentSource]);
};
